<template>
    <NonOpenSingle v-model="playerList"  v-if="typeCode==='PERSONAL' && singleList.includes(eventCode)"></NonOpenSingle>
    <NonOpenDouble v-model="playerList" v-else-if="typeCode === 'PERSONAL' && doubleList.includes(eventCode)"></NonOpenDouble>
</template>
<script>
    import NonOpenDouble from "./NonOpenDouble";
    import NonOpenSingle from "./NonOpenSingle";
    import participantMixin from "../../../mixins/participantMixin";
    export default{
        mixins: [participantMixin],
        components: {NonOpenDouble, NonOpenSingle},
        created() {
            this.loadingCheck = true

            const _this = this
            this.$store.dispatch('participants/getClub', this.$route.params).then(() => {
                _this.loadingCheck = false
            })
        }
    }
</script>
